import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Autoplay } from "swiper/core";
import "swiper/swiper-bundle.css";

// data needs to be an array of images src https://picsum.photos/1200/400
// options { }
const Slider = ({ data }) => {
  SwiperCore.use([Autoplay, Pagination]);

  if (!data) return <p>No images available</p>;

  // console.log(data);

  return (
    <div className="image-slider">
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        className="mySwiper"
      >
        {data.map((item) => (
          <SwiperSlide key={item.public_id}>
            <img src={item.url} alt="" />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Slider;
